import { register } from '@shopify/theme-sections';
import * as React from "react";
import * as ReactDOM from "react-dom";
import FavouritesList from '../components/Favourites/FavouritesList';

register('wishlist', {
    onLoad() {
        ReactDOM.render(React.createElement(FavouritesList, {
            moneyFormat: window.theme.moneyFormat,
            favouritesEmptyHTML: window.favouritesEmptyHTML
        }), document.getElementById('wishlist-dom')); 
    }
});
